import React from 'react';
import { Radio } from 'baseui/radio';
import { IDummyProps } from './types';
import { overrides as customOverrides } from './overrides';
import { getHTMLAttributes } from '../../Utilities/utils/Funtions/data-aria-attrs';
import { useStyletron } from '../../Themes';
import { mergeOverrides } from 'baseui';

export const View = React.forwardRef((props: IDummyProps, ref: any) => {
	const HTMLAttrs = getHTMLAttributes(props);
	const { overrides, ...rest } = props;
	const [css] = useStyletron();

	return (
		<div className={props.className + ' ' + css({ maxWidth: '100%' })}>
			<Radio
				{...rest}
				ref={ref}
				overrides={
					overrides
						? mergeOverrides(
							customOverrides(props, HTMLAttrs.dataProps, HTMLAttrs.ariaProps),
							overrides as any,
						)
						: customOverrides(props, HTMLAttrs.dataProps, HTMLAttrs.ariaProps)
				}
			/>
		</div>
	);
});
